var map = {
	"./Americano Tempura psd 1.jpg": 6708,
	"./Avocado Yaki.jpg": 2387,
	"./Chicken Ceaser Roll psd 1.jpg": 6646,
	"./Chicken Maki psd 1.jpg": 4277,
	"./Crab Stick Tempura.jpg": 5315,
	"./Dragon Roll psd 1.jpg": 8717,
	"./Ebi Tempura psd 1.jpg": 860,
	"./Hot Canadian Roll psd 1.jpg": 1149,
	"./Philadelphia Yaki.jpg": 5222,
	"./Sake Tempura psd 1.jpg": 5671,
	"./Salmon Gunkan yaki.jpg": 4688,
	"./Salmon Tempura.jpg": 1467,
	"./Shrimp Gunkan yaki.jpg": 2571,
	"./Shrimp Tempura Roll psd 1.jpg": 6747,
	"./Sushi Vibe Roll.jpg": 3308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9708;